import { ArrowUpRight } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { SITE, buildWhatsAppLink } from "@/data/site";
import { useLang, u } from "@/data/i18n";

export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();
  const { lang } = useLang();
  const go = (e, href) => {
    e.preventDefault();
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => window.__lenis?.scrollTo(href, { offset: -60 }), 200);
    } else {
      window.__lenis?.scrollTo(href, { offset: -60 });
    }
  };

  return (
    <footer data-testid="site-footer" className="noise-overlay relative bg-leaf-deep text-white overflow-hidden">
      <div className="max-w-[1500px] mx-auto px-5 md:px-10 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <img src={`${process.env.PUBLIC_URL}/assets/logo.png`} alt="Lovely Foodpacks" className="h-16 w-auto bg-white p-2" />
            <p className="mt-6 font-serif italic text-xl md:text-2xl text-sun">"{u(lang, "footer_tagline")}"</p>
            <p className="mt-4 text-white/60 text-sm leading-relaxed max-w-sm">
              {u(lang, "footer_about")}
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs tracking-[0.25em] uppercase font-bold text-sun">{u(lang, "footer_explore")}</p>
            <nav className="mt-5 flex flex-col gap-3">
              {[["nav_products", "#products"], ["nav_legacy", "#legacy"], ["nav_presence", "#presence"], ["nav_manufacturing", "#manufacturing"], ["nav_contact", "#contact"]].map(([key, href]) => (
                <a key={href} href={href} onClick={(e) => go(e, href)} data-testid={`footer-nav-${key.replace("nav_", "")}`} className="text-white/70 hover:text-sun transition-colors duration-300 text-sm font-semibold">
                  {u(lang, key)}
                </a>
              ))}
            </nav>
          </div>

          <div className="md:col-span-4">
            <p className="text-xs tracking-[0.25em] uppercase font-bold text-sun">{u(lang, "footer_reach")}</p>
            <div className="mt-5 flex flex-col gap-3 text-sm text-white/70">
              <a data-testid="footer-whatsapp" href={buildWhatsAppLink("Hello Lovely Foodpacks!")} target="_blank" rel="noreferrer" className="hover:text-sun transition-colors">WhatsApp Sales — {SITE.whatsappDisplay}</a>
              <a data-testid="footer-office" href="tel:+914562275519" className="hover:text-sun transition-colors">Office — {SITE.officeDisplay}</a>
              <a data-testid="footer-director" href="tel:+919442223442" className="hover:text-sun transition-colors">Director — {SITE.directorDisplay}</a>
              <a data-testid="footer-email" href={`mailto:${SITE.email}`} className="hover:text-sun transition-colors">{SITE.email}</a>
              <a data-testid="footer-indiamart" href={SITE.indiamart} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 font-bold text-white hover:text-sun transition-colors">
                IndiaMART Store <ArrowUpRight size={14} />
              </a>
              <p className="pt-3 border-t border-white/10 leading-relaxed">{SITE.hoAddress}</p>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-white/40">
          <p>© {new Date().getFullYear()} {SITE.brand} · {SITE.parent} · {u(lang, "footer_rights")}</p>
          <p>{u(lang, "footer_products_line")}</p>
        </div>
      </div>
    </footer>
  );
}
